var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerBgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.712 52.585l-.72-2.37-.261-.864-3.767-12.389-2.02-6.632-3.056-10.059H11.87l-1.882 6.596-1.502 5.259-1.503 5.258-1.37 4.801-2.97 10.4H0v3.946h28.217v-3.946h-2.505z",
    fill: "#54526B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.421 54.014H.056v6.052h177.365v-6.052z",
    fill: "#54526B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.265 52.83L25.37 10.435h5.04l12.877 42.352-30.022.041z",
    fill: "#FF6C22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.15 51.517H10.28v5.014h35.87v-5.014z",
    fill: "#E0682B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3 23.226l-11.322-4.41-1.912 6.688 15.795 6.149-2.56-8.427zM19.159 32.192l-1.912 6.687 24.736 9.622-2.56-8.427-20.264-7.882z",
    fill: "#ECEFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.055 48.501l-.337-1.098-4.785-15.75-2.566-8.427-3.885-12.79h-4.887l3.23 10.634.655 2.156 1.907 6.27.654 2.157 1.907 6.265 2.56 8.427.323 1.058.332 1.098.92 3.016h4.887l-.915-3.016z",
    fill: "#666",
    opacity: 0.18
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.447.137l10.577 56.476h-5.675L119.182.137h5.265z",
    fill: "#333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.948.137l10.576 56.476h-5.674L116.682.137h5.266z",
    fill: "#666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.539.137l10.57 56.476h-5.673L60.268.137h5.27z",
    fill: "#333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.034.137L73.61 56.613h-5.669L57.77.137h5.265z",
    fill: "#666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.946.137L41.411 56.613h5.674L57.2 0l-5.255.137z",
    fill: "#4D4D4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.322 30.686H55.979l-1.886-1.815L113.436.137l1.886 1.821v28.728z",
    fill: "#99A6B5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.093 28.87h7.11l-7.11-8.604v8.605zM78.298.137l23.754 28.734h11.384v-2.828L92.018.137h-13.72zM54.093.137v3.5L74.954 28.87h13.342L64.542.137H54.093zM113.436.137h-7.662l7.662 9.271V.138z",
    fill: "#ECEFF1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.093 20.266l7.11 8.605h13.751L54.094 3.636v16.63zM64.542.137l23.754 28.734h13.756L78.298.137H64.542zM105.774.137H92.018l21.418 25.906V9.408l-7.662-9.27z",
    fill: "#FF6C22"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.322 30.686l-1.886-1.815H54.093l1.856 1.846 59.373-.03z",
    fill: "#B2B2B2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.013.137l-10.536 56.476h5.674L121.375.137h-5.362z",
    fill: "#4D4D4D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.347 41.397H45.429V46.1h63.918v-4.704z",
    fill: "#4D4D4D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.575 39.195H44.657v4.704h63.918v-4.704z",
    fill: "#999"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.828.137l-10.53 56.476h5.669L54.088 0l-5.26.137zM113.436.137l-10.535 56.476h5.674L118.645.137h-5.209z",
    fill: "#999"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M174.916 53.23l-.721-2.369-.26-.865-3.768-12.388-2.014-6.632-3.057-10.059H161.073l-1.881 6.596-1.503 5.259-1.503 5.258-1.37 4.8-2.97 10.4h-2.642v3.947h28.217v-3.946h-2.505z",
    fill: "#54526B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.635 52.83l12.105-42.394h5.04l12.877 42.352-30.022.041z",
    fill: "#FF6C22"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M159.519 51.517H123.65v5.014h35.869v-5.014z",
    fill: "#E0682B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M147.67 23.226l-11.323-4.41-1.911 6.688 15.795 6.149-2.561-8.427zM132.529 32.192l-1.912 6.687 24.736 9.622-2.561-8.427-20.263-7.882z",
    fill: "#ECEFF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M155.425 48.501l-.338-1.098-4.789-15.75-2.561-8.427-3.885-12.79h-4.887l3.23 10.634.655 2.156 1.906 6.27.655 2.157 1.906 6.265 2.561 8.427.322 1.058.333 1.098.915 3.016h4.887l-.91-3.016z",
    fill: "#666",
    opacity: 0.18
  })));
}
export default SvgBannerBgIcon;